import styled from 'styled-components';
import { TransparentButton, Typography } from '@libs/components';
import { CirclePendingIcon, CircleCheckIcon } from 'src/assets';

type ProcessProps = {
  isWaiting?: boolean;
};
export const HeaderBodyWrapper = styled.div`
  padding: 2rem;
  border-radius: ${({ theme }) => theme.borderRadius.highM};
  background-color: ${({ theme }) => theme.colors.surface.default};
  box-shadow: ${({ theme }) => theme.shadows.lg};
`;
export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;
export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 1.6rem;
`;
export const AssetContianer = styled.div`
  display: flex;
  align-items: center;
  padding: 1.6rem 1.6rem 1.6rem 2.4rem;
  border-radius: ${({ theme }) => theme.borderRadius.x3};
  background-color: ${({ theme }) => theme.colors.surface.interactiveDefault};
  width: 100%;
`;
export const AssetIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 1.6rem;
`;
export const AssetInfoTitle = styled(Typography)`
  color: ${({ theme }) => theme.colors.text.secondary};
`;
export const AssetInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  padding-left: 1.6rem;
  border-left: 1px solid ${({ theme }) => theme.colors.borders.default};
  height: 100%;
`;
export const AssetRateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  white-space: nowrap;
`;
export const AssetRateArrowWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.borderRadius.highest};
  background-color: ${({ theme }) => theme.colors.surface.interactiveDefault};
  width: 2rem;
  height: 2rem;
`;
export const Body = styled.div`
  display: flex;
  padding-top: 2.4rem;
  position: relative;
  z-index: 100;
`;
export const ProcessContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  flex-grow: 1;
  padding-left: 1.6rem;
  border-left: 1px solid ${({ theme }) => theme.colors.borders.default};
  &:first-child {
    border: none;
  }
`;
export const FlexCenter = styled.div`
  display: flex;
  align-items: center;
`;
export const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CustomPendingIcon = styled(CirclePendingIcon)<ProcessProps>`
  width: 1.5rem;
  height: 1.5rem;
  fill: ${({ theme, isWaiting }) =>
    isWaiting ? theme.colors.text.pending : theme.colors.text.secondary};
  margin-right: 0.5rem;
  path {
    fill: ${({ theme, isWaiting }) =>
      isWaiting ? theme.colors.text.pending : theme.colors.text.secondary};
  }
`;
export const CustomCheckIcon = styled(CircleCheckIcon)<ProcessProps>`
  width: 1.5rem;
  height: 1.5rem;
  fill: ${({ theme, isWaiting }) =>
    isWaiting ? theme.colors.text.success : theme.colors.text.secondary};
  margin-right: 0.5rem;
  path {
    fill: ${({ theme, isWaiting }) =>
      isWaiting ? theme.colors.text.success : theme.colors.text.secondary};
  }
`;
export const Image = styled.img`
  width: 3.6rem;
  height: 3.6rem;
`;
export const LottieWrapper = styled.div`
  width: 2.4rem;
  height: 2.4rem;
`;
export const Footer = styled.div`
  display: flex;
  border-bottom-left-radius: ${({ theme }) => theme.borderRadius.highM};
  border-bottom-right-radius: ${({ theme }) => theme.borderRadius.highM};

  border: 1px solid ${({ theme }) => theme.colors.borders.default};
  border-top: none;
  margin-top: -1.5rem;
  position: relative;
  z-index: 1;
  gap: 2.4rem;
  padding: 3.9rem 2.4rem 2.4rem 0;
`;
export const FooterInfoContainer = styled.div`
  display: Flex;
  justify-content: center;
  flex-direction: column;
  padding-left: 2.4rem;
  flex-grow: 1;
  border-left: 1px solid ${({ theme }) => theme.colors.borders.default};
  gap: 0.8rem;
  &:first-child {
    border: none;
  }
`;
export const SwapDetailsButton = styled(TransparentButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 4.8rem;
  padding: 0 1.6rem;
  border-radius: ${({ theme }) => theme.borderRadius.x14};
  border: 1px solid ${({ theme }) => theme.colors.text.default};
`;
